module.exports = __webpack_public_path__ + "static/img/qiye.78c41169.png";